import { FileTypes } from "./enums";

export const fileTypes = [
    { id: FileTypes.Cover, name: 'Cover' },
    { id: FileTypes.Image, name: 'Image' },
    { id: FileTypes.Video, name: 'Video' }, 
  ];   

export const allowedFileTypes = ["image/jpeg","image/jpg", "image/png", "image/gif", "application/pdf"];

export const allowedImageExtensions = ['jpg', 'jpeg', 'png' ,'gif'];
export const allowedVideoExtensions = ['mp4', 'mov', 'avi', 'mkv'];
